import React, { lazy } from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

const NotFound = lazy(() => import("../../container/pages/404"));
const Maintenance = lazy(() => import("../../container/pages/Maintenance"));
const BlankPage = lazy(() => import("../../container/pages/BlankPage"));
const Settings = lazy(() =>
  import("../../container/profile/settings/Settings")
);

// const ChangeLog = lazy(() => import("../../container/pages/ChangeLog"));

function PagesRoute() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/404`} component={NotFound} />
      <Route path={`${path}/maintenance`} component={Maintenance} />
      <Route path={`${path}/starter`} component={BlankPage} />
      <Route path={`${path}/settings`} component={Settings} />
      {/* <Route path={`${path}/changelog`} component={ChangeLog} /> */}
    </Switch>
  );
}

export default PagesRoute;
